<form action="" *ngIf="form" (submit)="handleSubmit($event)" #formElem>
  <ng-container *ngFor="let field of config">
    <ng-container otDynamicField [config]="field" [group]="form" [errors]="errors" *ngIf="field.type != 'hidden'"
      [rootGroup]="form" otDynamicCondition>
    </ng-container>
  </ng-container>
  <ng-content></ng-content>
</form>